import { NameFormat, formatName } from 'src/utils/nameFormatting';

export type GroupMember = { clientId: string; firstName: string; lastName: string };

/**
 * "Tom H." · "Tom H. & Anna H." · "Tom H. & 2 others" — the column stays one line wide however
 * many members share an item, with the full names left to the cell's tooltip.
 */
export function appliesToLabel(members: GroupMember[]): string {
  const short = members.map(m => formatName(m.firstName, m.lastName, NameFormat.SHORT_SURNAME));
  if (short.length === 0) return '';
  if (short.length === 1) return short[0];
  if (short.length === 2) return `${short[0]} & ${short[1]}`;
  return `${short[0]} & ${short.length - 1} others`;
}

export function appliesToFullNames(members: GroupMember[]): string {
  return members
    .map(m => formatName(m.firstName, m.lastName, NameFormat.NATURAL))
    .filter(Boolean)
    .join(', ');
}
